import { render, staticRenderFns } from "./TenantEdit.vue?vue&type=template&id=7460635e&"
import script from "./TenantEdit.vue?vue&type=script&lang=ts&"
export * from "./TenantEdit.vue?vue&type=script&lang=ts&"
import style0 from "./TenantEdit.vue?vue&type=style&index=0&id=7460635e&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports